export default __webpack_public_path__ + "static/media/img_drive_with_blink.3efa4855.png";